enum fetchStatus {
    idle='idle',
    loading='loading',
    succeeded='succeeded',
    failed="failed"
}

export default fetchStatus
